import { StudentExamPaperList } from './StudentExamPaperList';
export default StudentExamPaperList;